import { useNavigate } from "react-router-dom";
import { useCart, useCurrency } from "../App";
import { ShoppingBag } from "lucide-react";

export default function FloatingCart() {
  const navigate = useNavigate();
  const { cart, getTotal, getItemCount } = useCart();
  const { symbol } = useCurrency();

  if (cart.length === 0) return null;

  return (
    <button
      onClick={() => navigate("/cart")}
      className="fixed bottom-36 right-4 z-50 flex items-center gap-3 bg-green-600 hover:bg-green-700 text-white pl-4 pr-5 py-3 rounded-2xl shadow-lg transition-all hover:scale-105 active:scale-95 min-w-[134px] justify-center"
      data-testid="floating-cart"
    >
      <div className="relative">
        <ShoppingBag size={18} />
        <span className="absolute -top-2 -right-2 w-4 h-4 bg-white text-green-600 rounded-full text-[8px] font-bold flex items-center justify-center">
          {getItemCount()}
        </span>
      </div>
      <span className="text-xs font-bold">{symbol}{Math.round(getTotal())}</span>
    </button>
  );
}
